import type { ExternalBook } from '@/utils/searchRanking'

export function externalSelectPayload(book: ExternalBook) {
  return {
    book: {
      id: undefined,
      title: book.title,
      author: book.author,
      cover_url: book.cover_url,
      page_count: book.page_count,
      isbn: book.isbn,
      source: book.source,
      external_id: book.external_id,
      in_database: false,
    },
  }
}
